import Joi from 'joi';
import { COMMENT_MIN_LENGTH } from '../constants/ChangeDateRequestConstants';

const COMMENT_ERROR_MESSAGE = 'Comment field is required. Must be a minimum of 25 characters.';

const RequestDateInputValidator = {
  schema: Joi.object({
    startDate: Joi.date().required(),
    endDate: Joi.date().required(),
    comment: Joi.string().min(COMMENT_MIN_LENGTH).required().messages({
      'string.empty': COMMENT_ERROR_MESSAGE,
      'string.min': COMMENT_ERROR_MESSAGE
    })
  })
};

export default RequestDateInputValidator;
